import gql from 'graphql-tag';

export const GET_FP_MARKUP_BY_ID = gql`
  query FinanceProgramMarkup($id: ID!) {
    financeProgramMarkup: financeProgram(id: $id) {
      paymentOptionsConfiguration
    }
  }
`;
